import { html } from 'lit';
const ImproveWriting =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M10.25 3a.75.75 0 0 0-1.5 0v3a.75.75 0 0 0 1.5 0zm0 10a.75.75 0 0 0-1.5 0v3a.75.75 0 0 0 1.5 0zm-3.5-3.5a.75.75 0 0 1-.75.75H3a.75.75 0 0 1 0-1.5h3a.75.75 0 0 1 .75.75m9.25.75a.75.75 0 0 0 0-1.5h-3a.75.75 0 0 0 0 1.5zM7.555 7.555a.75.75 0 0 1-1.06 0l-2.121-2.12a.75.75 0 1 1 1.06-1.061l2.121 2.12a.75.75 0 0 1 0 1.061M18.97 20.03a.75.75 0 1 0 1.06-1.06l-7.525-7.525a.75.75 0 0 0-1.06 1.06zM7.555 11.444a.75.75 0 0 1 0 1.061l-2.12 2.121a.75.75 0 1 1-1.061-1.06l2.12-2.122a.75.75 0 0 1 1.061 0m7.072-6.01a.75.75 0 0 0-1.061-1.06l-2.122 2.12a.75.75 0 1 0 1.061 1.061z" clip-rule="evenodd"/>
  </svg>
`;
export default ImproveWriting;
